import SEO from "@/components/common/SEO";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ComplianceCard from "@/components/landing/ComplianceCard";
import PartnerBanks from "@/components/landing/PartnerBanks";
import LoanCategories from "@/components/landing/LoanCategories";
import WhyChoose from "@/components/landing/WhyChoose";
import EligibilityForm from "@/components/landing/EligibilityForm";
import Process from "@/components/landing/Process";
import Stats from "@/components/landing/Stats";
import DSACareerSection from "@/components/landing/DSACareerSection";
import Testimonials from "@/components/landing/Testimonials";
import Awards from "@/components/landing/Awards";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingActions from "@/components/landing/FloatingActions";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";
import CalculatorsSection from "@/components/landing/CalculatorsSection";

import {
  websiteSchema,
  organizationSchema,
  financialServiceSchema,
  localBusinessSchema,
} from "../components/common/schema";

const schemas = [
  websiteSchema(),
  organizationSchema(),
  financialServiceSchema(),
  localBusinessSchema(),
];

export default function Landing() {
  const location = useLocation();

  const scrollToEligibility = useCallback(() => {
    const el = document.getElementById("eligibility");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  useEffect(() => {
    const id = location.hash.replace(/^#/, "");

    if (!id) {
      return;
    }

    const scrollToHash = () => {
      const element = document.getElementById(id);

      if (!element) {
        return;
      }

      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    };

    // Wait until the landing page sections have rendered.
    const timer = window.setTimeout(scrollToHash, 100);

    return () => {
      window.clearTimeout(timer);
    };
  }, [location.hash]);

  return (
    <>
      <SEO
        title="Home Loans, Mortgage, Business & Construction Loans | Money Mart"
        description="Money Mart helps you compare and apply for Home Loans, Mortgage Loans, Business Loans, Construction Loans, LAP, Personal Loans and more from leading Banks and NBFCs."
        canonical="/"
        structuredData={schemas}
      />
      <main data-testid="landing-page" className="min-h-screen bg-white">
        <Header onCtaClick={scrollToEligibility} />
        <Hero onCheckEligibility={scrollToEligibility} />
        <ComplianceCard />
        <PartnerBanks />
        <LoanCategories />
        <CalculatorsSection />
        <WhyChoose />
        <EligibilityForm />
        <Process />
        <Stats />
        <DSACareerSection />
        <Testimonials />
        <Awards />
        <FAQ />
        <Contact />
        <Footer />
        <FloatingActions />
        <StickyMobileCTA onCheckEligibility={scrollToEligibility} />
        {/* Bottom spacer for sticky mobile CTA */}
        <div className="md:hidden h-16" aria-hidden="true" />
      </main>
    </>
  );
}
